<template>
  <div>
    <div class="date-picker-container">
            <span class="date-picker-container__heading">
                {{ createChapterStudioConstant.FORM_FIELD.DISPLAY_RANGE }}
            </span>
      <ypo-date-range
          :endDateLabel="createChapterStudioConstant.END_DATE"
          :endDateValue="announcement.displayEndDate"
          :startDateLabel="createChapterStudioConstant.START_DATE"
          :startDateValue="announcement.displayStartDate"
          @updateDateRange="updateDisplayDate"
      />
    </div>
    <div v-if="announcement.recordTypeName === createChapterStudioConstant.RECORD_TYPE.IMAGE"
         class="date-picker-container">
            <span class="date-picker-container__heading">
                {{ createChapterStudioConstant.FORM_FIELD.EFFECTIVE_RANGE }}
            </span>
      <ypo-date-range
          :endDateLabel="createChapterStudioConstant.END_DATE"
          :endDateValue="announcement.effectiveEndDate"
          :startDateLabel="createChapterStudioConstant.START_DATE"
          :startDateValue="announcement.effectiveStartDate"
          @updateDateRange="updateEffectiveDate"
      />
    </div>
  </div>
</template>

<script>
import YpoDateRange from "@/components/YpoDateRange/YpoDateRange.vue";
import {
  createChapterStudioConstant,
  manageChapterStudioConstant,
} from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";

export default {
  components: { YpoDateRange },
  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      createChapterStudioConstant,
      manageChapterStudioConstant,
      isWrongEntry: false,
    };
  },
  methods: {
    updateDisplayDate(dateRange) {
      const { startDate, endDate } = dateRange;
      this.$emit("emitDisplayDateRange", { displayStartDate: startDate, displayEndDate: endDate });
    },
    updateEffectiveDate(dateRange) {
      const { startDate, endDate } = dateRange;
      this.$emit("emitEffectiveDateRange", { effectiveStartDate: startDate, effectiveEndDate: endDate });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.date-picker-container {
  font-family: Roboto, 'sans-serif';

  &__heading {
    color: $ypo-blue;
    font-weight: 600;
    font-size: 18px;
  }
}
</style>
